function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_INVESTMENTITEMFOLLOWER_REQUEST = "POST_INVESTMENTITEMFOLLOWER_REQUEST";
export var POST_INVESTMENTITEMFOLLOWER_SUCCESS = "POST_INVESTMENTITEMFOLLOWER_SUCCESS";
export var POST_INVESTMENTITEMFOLLOWER_FAILURE = "POST_INVESTMENTITEMFOLLOWER_FAILURE";
export var RESET_POST_INVESTMENTITEMFOLLOWER = "RESET_POST_INVESTMENTITEMFOLLOWER";
export var postInvestmentItemFollower = function postInvestmentItemFollower(investmentItemFollower) {
  var endpoint = "investmentItemFollowers";
  if (investmentItemFollower.id) endpoint += "/".concat(investmentItemFollower.id);
  return _defineProperty({
    investmentItemFollower: investmentItemFollower
  }, CALL_API, {
    types: [POST_INVESTMENTITEMFOLLOWER_REQUEST, POST_INVESTMENTITEMFOLLOWER_SUCCESS, POST_INVESTMENTITEMFOLLOWER_FAILURE],
    endpoint: endpoint,
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(investmentItemFollower),
      credentials: "same-origin"
    }
  });
};
export var DELETE_INVESTMENTITEMFOLLOWER_REQUEST = "DELETE_INVESTMENTITEMFOLLOWER_REQUEST";
export var DELETE_INVESTMENTITEMFOLLOWER_SUCCESS = "DELETE_INVESTMENTITEMFOLLOWER_SUCCESS";
export var DELETE_INVESTMENTITEMFOLLOWER_FAILURE = "DELETE_INVESTMENTITEMFOLLOWER_FAILURE";
export var RESET_DELETE_INVESTMENTITEMFOLLOWER = "RESET_DELETE_INVESTMENTITEMFOLLOWER";
export var deleteInvestmentItemFollower = function deleteInvestmentItemFollower(investmentItemFollower) {
  return _defineProperty({
    investmentItemFollower: investmentItemFollower
  }, CALL_API, {
    types: [DELETE_INVESTMENTITEMFOLLOWER_REQUEST, DELETE_INVESTMENTITEMFOLLOWER_SUCCESS, DELETE_INVESTMENTITEMFOLLOWER_FAILURE],
    endpoint: "investmentItemFollowers/".concat(investmentItemFollower.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};